import { render, staticRenderFns } from "./Template50.vue?vue&type=template&id=4c0ab4e4&scoped=true&"
import script from "./Template50.vue?vue&type=script&lang=js&"
export * from "./Template50.vue?vue&type=script&lang=js&"
import style0 from "./Template50.vue?vue&type=style&index=0&id=4c0ab4e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0ab4e4",
  null
  
)

export default component.exports